import React, { useEffect } from 'react'
import NotPermission from '../app/pages/components/NotPermission'
import { useAuthStore } from '../store/authStore'

export default function usePermission() {
  const [isNotPermission, setIsNotPermission] = React.useState(false)
  const [permissionMessage, setPermissionMessage] = React.useState<string | undefined>(undefined)
  const org = useAuthStore((state) => state.orgId)
  useEffect(() => {
    setIsNotPermission(false)
  }, [org])
  function getPermission(status: number | string, message?: string) {

    if (status === 403 || status === '403') {
      setIsNotPermission(true)
      setPermissionMessage(message)
    }
  }

  function isPermission() {
    if (isNotPermission) {
      return <NotPermission message={permissionMessage} />
    } else {
      return null
    }
  }

  return { isPermission, getPermission }
}
